var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [_c("stepheader", { attrs: { step: _vm.step } }), _vm._v(" "), _vm._m(0)],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticClass: "body current",
        attrs: {
          id: "wizard2-p-0",
          role: "tabpanel",
          "aria-labelledby": "wizard2-h-0",
          "aria-hidden": "false",
        },
      },
      [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-12 text-center" }, [
            _vm._v("\n              Grazie per la segnalazione"),
            _c("br"),
            _vm._v("\nRiceverai informazioni dal nostro Staff al più presto"),
            _c("br"),
            _c("br"),
            _vm._v("\nGrazie per averci contattati\n\n            "),
          ]),
        ]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }